import axios from 'axios';
import { queryClient } from './queryClient.ts';
import { resetAllState } from './resetAll.ts';
import { addToast, store } from '../store/index.ts';

const axiosClient = axios.create();

const MAX_NETWORK_RETRIES = 3;

function isNetworkError(error: any) {
  return !error?.response && (error?.code === 'ERR_NETWORK' || !!error?.message);
}

function wait(ms: number) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

axiosClient.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config || {};
    const status = error?.response?.status;

    if (status === 401) {
      resetAllState(store.dispatch, queryClient);
      window.location.assign('/login');
      return Promise.reject(error);
    }

    if (status === 500 || status === 503) {
      store.dispatch(
        addToast({
          type: 'error',
          message: 'Server error. Please try again.',
          autoDismiss: false,
        })
      );
      return Promise.reject(error);
    }

    if (isNetworkError(error)) {
      originalRequest.__networkRetryCount =
        (originalRequest.__networkRetryCount || 0) + 1;

      if (originalRequest.__networkRetryCount <= MAX_NETWORK_RETRIES) {
        const retryDelayMs = 300 * 2 ** (originalRequest.__networkRetryCount - 1);
        await wait(retryDelayMs);
        return axiosClient(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
